module.exports = __webpack_public_path__ + "static/img/banner2.9f3f786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner2.png
// module id = 6XiN
// module chunks = 2